import CardContext from '../context/CardContext';
import { useState, useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function CardNew( { card, index = undefined, handleVisibilityUpdate, editVisible, display } ) {
    const { addCard, updateCard } = useContext(CardContext);
    const [editFieldsVisible, setEditFieldsVisible] = useState(false);

    const { img = '', link = '', title = '', text = '' } = card;

    const [newCardImage, setNewCardImage] = useState(img);
    const [newCardLink, setNewCardLink] = useState(link);
    const [newCardTitle, setNewCardTitle] = useState(title);
    const [newCardText, setNewCardText] = useState(text);

    const resetStates = () => {
        setNewCardImage('');
        setNewCardLink('');
        setNewCardTitle('');
        setNewCardText('');
    }

    const handleCardData = () => {
        const newCard = {
            img : newCardImage,
            link : newCardLink,
            title : newCardTitle,
            text : newCardText
        };
        if ( typeof index !== 'undefined' ) { 
            updateCard(index, newCard); 
            resetStates();
            return; 
        }

        addCard(newCard);
        resetStates();
    }

    const handleCardUIUpdate = () => {
        setEditFieldsVisible(editFieldsVisible ? false : true);
        handleVisibilityUpdate();

        if(editFieldsVisible === true) {
            handleCardData();
        }
    }

    return (
        <li key="editing" className="card-item-add" style={{'display': `${display}` }}>
            <div className={`cart-item-add-fields ${editVisible ? 'active' : ''}`}>
                <label className="card-input-group"><FontAwesomeIcon icon="image" /><input value={newCardImage} onChange={ (e) => setNewCardImage(e.target.value) } /></label>
                <label className="card-input-group"><FontAwesomeIcon icon="link" /><input value={newCardLink} onChange={ (e) => setNewCardLink(e.target.value) } /></label>
                <label className="card-input-group"><FontAwesomeIcon icon="heading" /><input value={newCardTitle} onChange={ (e) => setNewCardTitle(e.target.value) } /></label>
                <label className="card-input-group"><FontAwesomeIcon icon="paragraph" /><input value={newCardText} onChange={ (e) => setNewCardText(e.target.value) } /></label>
            </div>
            <button className={`button-add-card ${editVisible ? 'small' : ''}`} onClick={handleCardUIUpdate}>
                {
                editFieldsVisible ? 
                <FontAwesomeIcon icon="check" inverse /> : 
                <FontAwesomeIcon icon="plus" inverse />
                }
                {editFieldsVisible ? '' : ' New' }
            </button>
        </li>
    );
  }
  
  export default CardNew;
  